import { useEffect } from 'react';

export default function LightboxModal({ isOpen, images = [], currentIndex = 0, onClose, onPrev, onNext }) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onPrev();
      if (e.key === 'ArrowRight') onNext();
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex] || images[0];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-fadeIn">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 w-12 h-12 text-white/80 hover:text-white flex items-center justify-center text-2xl transition-colors"
        aria-label="Luk stor visning"
      >
        <i className="fa-solid fa-xmark"></i>
      </button>

      {/* Prev button */}
      {images.length > 1 && (
        <button
          onClick={onPrev}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 text-white/80 hover:text-white flex items-center justify-center text-2xl transition-colors"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      )}

      {/* Main Image */}
      <div className="max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={currentImage}
          alt="Stor visning af projekt"
          className="max-w-full max-h-[75vh] object-contain rounded-lg shadow-2xl border border-stone-800"
        />
        {images.length > 1 && (
          <div className="mt-4 text-xs font-semibold text-stone-400 bg-stone-900/80 px-4 py-1.5 rounded-full border border-stone-800">
            {currentIndex + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Next button */}
      {images.length > 1 && (
        <button
          onClick={onNext}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-50 w-12 h-12 text-white/80 hover:text-white flex items-center justify-center text-2xl transition-colors"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right"></i>
        </button>
      )}
    </div>
  );
}
